import React from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiOutlinePlus } from 'react-icons/ai'
import { useState } from 'react'
import { useEffect } from 'react'
import { activeStatus, fetchAllDataAPI, removeDataFromList } from '../../utils/api'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { Table } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { FaEdit, FaEye, FaRegTrashAlt } from 'react-icons/fa'
import moment from 'moment'
import withAuth from '../../utils/withAuth'

const Employee = () => {
    const [employee, setEmployee] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 10;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = employee.slice(firstIndex, lastIndex);
    const npage = Math.ceil(employee.length / recordPerPage)
    const numbers = [...Array(npage + 1).keys()].slice(1)

    useEffect(() => {
        getAllEmployee();
    }, []);

    const getAllEmployee = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-all-employee').then((res) => {
            if (res.data.status === 1) {
                setIsLoading(false);
                setEmployee(...[res.data.employee]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }
    const handleStatusActive = (empid) => {
        activeStatus('hr-active-employee-status', empid).then((res) => {
            if (res.data.status === 1) {
                setEmployee((prevEmployees) =>
                    prevEmployees.map((emp) =>
                        emp.employee_id === empid ? { ...emp, emp_status: 'Active' } : emp
                    )
                );
                toast.success('Employee Activated Successfully!');
            }
        });
    };
    
    const handleStatusInactive = (empid) => {
        activeStatus('hr-inactive-employee-status', empid).then((res) => {
            if (res.data.status === 1) {
                setEmployee((prevEmployees) =>
                    prevEmployees.map((emp) =>
                        emp.employee_id === empid ? { ...emp, emp_status: 'Inactive' } : emp
                    )
                );
                toast.success('Employee Deactivated Successfully!');
            }
        });
    };
    const handleDesignationRemoveHr = (empid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('hr-remove-employee', empid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getAllEmployee();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="employeepage">
            <Helmet>
                <title>SATKARTAR::HR::EMPLOYEES</title>
            </Helmet>

            <ContentWrapper>
                <div className="card employeepage">
                    <h5 className="mb-0 text-uppercase">
                        All Employees
                        <Link to="/add-employee" className="btnemployee" style={{ fontSize: "12px" }}><AiOutlinePlus /> Add Employee</Link>
                    </h5>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Emp Code</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>DOJ</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 8 }).map((_, index) => (
                                                    <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) : records.length > 0 ? (
                                    records?.map((record, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {record?.emp_name}

                                                {(() => {
                                                    if (record?.emp_leave_status === "Inactive") {
                                                        return (
                                                            <div className="sticky_header__availabl">
                                                                <span className="sticky_header__available_circle"></span>
                                                                <p>Available for work</p>
                                                            </div>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <div className="sticky_header__navailabl">
                                                                <span className="sticky_header__navailable_circle"></span>
                                                                <p>Not available for work</p>
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td><span className="badge bg-success">{record?.emp_code}</span></td>
                                            <td>{record?.emp_mobile}</td>
                                            <td>{record?.emp_company_email}</td>
                                            <td>{record?.emp_job_role}</td>
                                            <td>{moment(record?.emp_joining_date).format("MMMM Do YYYY")}</td>
                                            <td>
                                                {(() => {
                                                    if (record?.emp_status === "Active") {
                                                        return (
                                                            <span className="badge bg-success btnstatus" onClick={() => handleStatusActive(record?.employee_id)}>Active</span>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <span className="badge bg-danger btnstatus" onClick={() => handleStatusInactive(record?.employee_id)}>Inactive</span>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                <div className="d-flex" style={{ gap: "5px" }}>
                                                    <Link to={`/employee-details/${record?.emp_code}`} className="btnDisplay"><FaEye /></Link>
                                                    <button className="btnDelete" onClick={() => handleDesignationRemoveHr(record?.employee_id)}><FaRegTrashAlt /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={8}>Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Emp Code</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>DOJ</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <nav className="pagination-container">
                            <ul className="pagination align-items-center">
                                <li className="total-orders ml-2">Total: {employee.length}</li>
                            </ul>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={perPage} disabled={currentPage === 1}>
                                        Previous
                                    </button>
                                </li>
                                {numbers.map((n) => {
                                    if (
                                        n === 1 ||
                                        n === npage ||
                                        Math.abs(currentPage - n) <= 2
                                    ) {
                                        return (
                                            <li key={n} className={`page-item ${currentPage === n ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => changePage(n)}>
                                                    {n}
                                                </button>
                                            </li>
                                        );
                                    } else if (
                                        (n === currentPage - 3 && n > 1) ||
                                        (n === currentPage + 3 && n < npage)
                                    ) {
                                        return (
                                            <li key={n} className="page-item">
                                                <span className="page-link">...</span>
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                                <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={nextPage} disabled={currentPage === npage}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default withAuth(Employee)